(() => {
  const VARIANT_ID = 46082852880582;
  const PROP_KEY = 'Gift message';
  const STORAGE_KEY = 'fc_gift_wrap_pref';
  let busy = false;
  let messageTimer = null;
  let pendingCheckout = false;

  function root() {
    return window.Shopify?.routes?.root || '/';
  }

  function savePref(enabled, message) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ enabled: !!enabled, message: message || '' })
      );
    } catch (e) {}
  }

  function loadPref() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function clearPref() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function getProductGiftUI() {
    const wrap = document.querySelector('[data-gift-wrap-context="product"]');
    if (!wrap) return { checked: false, message: '', wrap: null };
    const checkbox = wrap.querySelector('[data-gift-wrap-checkbox]');
    const messageEl = wrap.querySelector('[data-gift-wrap-message]');
    return {
      wrap,
      checked: !!checkbox?.checked,
      message: (messageEl?.value || '').trim(),
      checkbox,
      messageEl,
    };
  }

  function getProductFormVariant() {
    const form = document.querySelector('product-form form[action*="/cart/add"], product-form form');
    if (!form) return null;
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!idInput?.value) return null;
    return {
      form,
      variantId: Number(idInput.value),
      quantity: Number(qtyInput?.value || 1) || 1,
    };
  }

  async function refreshSections() {
    const sections = await fetch(`${root()}?sections=cart-drawer,cart,cart-bubble`).then((r) => r.json());
    document.dispatchEvent(
      new CustomEvent('cart-update', {
        detail: { sections },
        bubbles: true,
      })
    );
  }

  async function getCart() {
    return fetch(`${root()}cart.js`, { credentials: 'same-origin' }).then((r) => r.json());
  }

  function findGiftWrapItem(cart) {
    return (cart.items || []).find((item) => Number(item.variant_id) === VARIANT_ID);
  }

  function findVariantInCart(cart, variantId) {
    return (cart.items || []).find((item) => Number(item.variant_id) === Number(variantId));
  }

  function hasOtherItems(cart) {
    return (cart.items || []).some((item) => Number(item.variant_id) !== VARIANT_ID);
  }

  function setLoading(el, on) {
    if (!el) return;
    el.classList.toggle('is-loading', !!on);
  }

  async function addItems(items) {
    const res = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  }

  async function ensureGiftWrapInCart(message) {
    const cart = await getCart();
    if (findGiftWrapItem(cart)) {
      if (message) await updateGiftMessage(message);
      return;
    }
    const properties = {};
    if (message) properties[PROP_KEY] = message;
    await addItems([{ id: VARIANT_ID, quantity: 1, properties }]);
  }

  async function ensureProductInCart(variantId, quantity) {
    const cart = await getCart();
    if (findVariantInCart(cart, variantId)) return;
    await addItems([{ id: Number(variantId), quantity: Number(quantity) || 1 }]);
  }

  async function addGiftWrap(message) {
    await ensureGiftWrapInCart(message);
    await refreshSections();
  }

  async function removeGiftWrap() {
    const cart = await getCart();
    const item = findGiftWrapItem(cart);
    if (!item) {
      await refreshSections();
      return;
    }

    const res = await fetch(`${root()}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    });
    const data = await res.json();
    if (!res.ok) throw data;
    await refreshSections();
  }

  async function updateGiftMessage(message) {
    const cart = await getCart();
    const item = findGiftWrapItem(cart);
    if (!item) return;

    const res = await fetch(`${root()}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: 1,
        properties: { [PROP_KEY]: message || '' },
      }),
    });
    const data = await res.json();
    if (!res.ok) throw data;
  }

  async function syncGiftWrapFromPref() {
    const pref = loadPref();
    const ui = getProductGiftUI();
    const enabled = ui.checked || !!pref?.enabled;
    if (!enabled || busy || pendingCheckout) return;

    const message = ui.message || pref?.message || '';
    const cart = await getCart();
    if (!hasOtherItems(cart)) return;
    if (findGiftWrapItem(cart)) return;

    busy = true;
    try {
      await ensureGiftWrapInCart(message);
      await refreshSections();
    } catch (err) {
      console.error('Gift wrap auto-add error:', err);
    } finally {
      busy = false;
    }
  }

  /**
   * Buy it now skips the cart — so we intercept it, put product + gift wrap
   * in the cart, then send the customer to /checkout.
   */
  async function checkoutWithGiftWrap(e) {
    const ui = getProductGiftUI();
    if (!ui.checked) return false;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const product = getProductFormVariant();
    if (!product?.variantId) {
      alert('Please select a product variant first.');
      return true;
    }

    pendingCheckout = true;
    busy = true;
    setLoading(ui.wrap, true);

    try {
      savePref(true, ui.message);
      await ensureProductInCart(product.variantId, product.quantity);
      await ensureGiftWrapInCart(ui.message);
      window.location.href = `${root()}checkout`;
    } catch (err) {
      console.error('Gift wrap checkout error:', err);
      alert('Sorry — could not add gift wrap. Please try Add to cart, then checkout.');
      pendingCheckout = false;
      busy = false;
      setLoading(ui.wrap, false);
    }
    return true;
  }

  function isBuyItNowTarget(target) {
    if (!target || !target.closest) return false;
    return !!(
      target.closest('.shopify-payment-button') ||
      target.closest('.shopify-payment-button__button') ||
      target.closest('[data-testid="Checkout-button"]') ||
      target.closest('shopify-accelerated-checkout') ||
      target.closest('.shopify-payment-button more-payment-options-link')
    );
  }

  // Capture phase so we run before Shopify's Buy it now handler
  document.addEventListener(
    'click',
    (e) => {
      if (!isBuyItNowTarget(e.target)) return;
      const ui = getProductGiftUI();
      if (!ui.checked) return;
      checkoutWithGiftWrap(e);
    },
    true
  );

  async function onCheckboxChange(e) {
    const checkbox = e.target;
    const wrap = checkbox.closest('[data-gift-wrap]');
    if (!wrap || busy) return;

    const context = wrap.getAttribute('data-gift-wrap-context') || 'cart';
    const messageWrap = wrap.querySelector('[data-gift-wrap-message-wrap]');
    const messageEl = wrap.querySelector('[data-gift-wrap-message]');
    const message = (messageEl?.value || '').trim();

    if (messageWrap) messageWrap.hidden = !checkbox.checked;
    savePref(checkbox.checked, message);

    if (context === 'product') {
      busy = true;
      setLoading(wrap, true);
      try {
        const cart = await getCart();
        if (checkbox.checked) {
          if (hasOtherItems(cart) || findGiftWrapItem(cart)) {
            await addGiftWrap(message);
          }
        } else {
          await removeGiftWrap();
          clearPref();
        }
      } catch (err) {
        console.error('Gift wrap error:', err);
        checkbox.checked = !checkbox.checked;
        if (messageWrap) messageWrap.hidden = !checkbox.checked;
        savePref(checkbox.checked, message);
        alert('Sorry — gift wrap could not be updated. Please try again.');
      } finally {
        setLoading(wrap, false);
        busy = false;
      }
      return;
    }

    busy = true;
    setLoading(wrap, true);
    try {
      if (checkbox.checked) {
        await addGiftWrap(message);
      } else {
        await removeGiftWrap();
        clearPref();
      }
    } catch (err) {
      console.error('Gift wrap error:', err);
      checkbox.checked = !checkbox.checked;
      if (messageWrap) messageWrap.hidden = !checkbox.checked;
      alert('Sorry — gift wrap could not be updated. Please try again.');
    } finally {
      setLoading(wrap, false);
      busy = false;
    }
  }

  function onMessageInput(e) {
    const wrap = e.target.closest('[data-gift-wrap]');
    const checkbox = wrap?.querySelector('[data-gift-wrap-checkbox]');
    const message = (e.target.value || '').trim();
    savePref(!!checkbox?.checked, message);

    if (!wrap || !checkbox?.checked) return;

    clearTimeout(messageTimer);
    messageTimer = setTimeout(async () => {
      if (busy) return;
      const cart = await getCart();
      if (!findGiftWrapItem(cart)) return;
      busy = true;
      setLoading(wrap, true);
      try {
        await updateGiftMessage(message);
        await refreshSections();
      } catch (err) {
        console.error('Gift message update error:', err);
      } finally {
        setLoading(wrap, false);
        busy = false;
      }
    }, 500);
  }

  function bind(rootEl = document) {
    rootEl.querySelectorAll('[data-gift-wrap]').forEach((wrap) => {
      if (wrap.dataset.bound === '1') return;
      wrap.dataset.bound = '1';

      if (wrap.getAttribute('data-gift-wrap-context') === 'product') {
        const pref = loadPref();
        const checkbox = wrap.querySelector('[data-gift-wrap-checkbox]');
        const messageEl = wrap.querySelector('[data-gift-wrap-message]');
        const messageWrap = wrap.querySelector('[data-gift-wrap-message-wrap]');
        if (pref?.enabled && checkbox && !checkbox.checked) {
          checkbox.checked = true;
          if (messageWrap) messageWrap.hidden = false;
          if (messageEl && pref.message) messageEl.value = pref.message;
        }
      }

      const checkbox = wrap.querySelector('[data-gift-wrap-checkbox]');
      const message = wrap.querySelector('[data-gift-wrap-message]');
      checkbox?.addEventListener('change', onCheckboxChange);
      message?.addEventListener('input', onMessageInput);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bind();
    syncGiftWrapFromPref();
  });

  document.addEventListener('cart-update', () => {
    setTimeout(() => {
      bind();
      if (!pendingCheckout) syncGiftWrapFromPref();
    }, 100);
  });

  // Also catch Add to cart completion via fetch hook
  const originalFetch = window.fetch;
  window.fetch = async function patchedFetch(input, init) {
    const response = await originalFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      if (url.includes('/cart/add') && !pendingCheckout) {
        const clone = response.clone();
        clone
          .json()
          .then(async () => {
            const ui = getProductGiftUI();
            const pref = loadPref();
            if (ui.checked || pref?.enabled) {
              await new Promise((r) => setTimeout(r, 150));
              await syncGiftWrapFromPref();
            }
          })
          .catch(() => {});
      }
    } catch (e) {}
    return response;
  };

  const observer = new MutationObserver(() => bind());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
